const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTrash(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "trash-alt"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M6.5 6L7.30086 18.0129C7.371 19.065 7.40607 19.5911 7.63332 19.99C7.83339 20.3412 8.13517 20.6235 8.49889 20.7998C8.91202 21 9.43927 21 10.4938 21H14.5062C15.5607 21 16.088 21 16.5011 20.7998C16.8648 20.6235 17.1666 20.3412 17.3667 19.99C17.5939 19.5911 17.629 19.065 17.6991 18.0129L18.5 6",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_2",
    d: "M4.5 6L20.5 6",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_3",
    d: "M16.5 6L16.2294 5.18807C15.9671 4.40125 15.8359 4.00784 15.5927 3.71698C15.3779 3.46013 15.1021 3.26132 14.7905 3.13878C14.4376 3 14.023 3 13.1936 3H11.8064C10.977 3 10.5624 3 10.2095 3.13878C9.89792 3.26132 9.62208 3.46013 9.40729 3.71698C9.16405 4.00784 9.03292 4.40125 8.77064 5.18807L8.5 6",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_4",
    d: "M14.5 10V17",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_5",
    d: "M10.5 10V17",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrash);
export default __webpack_public_path__ + "static/media/icon_trash.afd91ec1e57f89bbe41ff46985814ae9.svg";
export { ForwardRef as ReactComponent };